import { render, staticRenderFns } from "./OrderBar.vue?vue&type=template&id=44e3bfbc&scoped=true&"
import script from "./OrderBar.vue?vue&type=script&lang=js&"
export * from "./OrderBar.vue?vue&type=script&lang=js&"
import style0 from "./OrderBar.vue?vue&type=style&index=0&id=44e3bfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3bfbc",
  null
  
)

export default component.exports